import Rollbar from 'rollbar';

export const sharedBaseConfig: Rollbar.Configuration = {
  hostSafeList: ['sollishealth.com', 'vercel.app'],
  captureIp: 'anonymize',
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Disable telemetry due to it causing an infinite loop when trying to
  // serialize some kind of object into a string. See our Rollbar account.
  autoInstrument: false,
};

// Client-side config (browser)
export const clientConfig: Rollbar.Configuration = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  environment:
    process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NEXT_PUBLIC_NODE_ENV,
  ...sharedBaseConfig,
};
